module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0745b_banner_800x600.7e7c6d74.png";